import {Tr} from "@/i18n/i18n";
import {ShopCreature} from "@/store/shop/types";
import {Creature} from "@/store/level/types";
import {Keys} from "@/constants/key";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {MenuNewElementMarker} from "@/scenes.ui/menu-new-element-marker";
import {CreatureUtils} from "@/utils/creature-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "../utils/c-u";
import PlayerStore from "@/store/player";
import {Lang, Player} from "@/store/player/types";
import Image = Phaser.GameObjects.Image;
import OnceCaller from "@/utils/once-caller";
import GameObject = Phaser.GameObjects.GameObject;

export class CampaignCreaturePanel extends Phaser.GameObjects.Container {

    public static HEIGHT = 180;

    constructor(scene: Phaser.Scene, x: number, y: number, sc: ShopCreature, statClickCallback: (creatureId:string) => void, callback: () => void) {
        super(scene);

        this.scene = scene;
        this.x = x;
        this.y = y;
        let multiple= sc.creatures.length > 1;
        this.width = CU.CANVAS_WIDTH;
        this.height = CampaignCreaturePanel.HEIGHT + (multiple? sc.creatures.length * 70 +45: 0);

        const creatures: Creature[] = sc.creatures;
        const back = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_PANEL_BACK, 0.77, this.height/CampaignCreaturePanel.HEIGHT).setOrigin(0, 0);

        let dx = 0;
        let dx2 = multiple? -110: 0;
        let dy = multiple? 35 : 0;
        let dy2 = multiple? 185 : 0;
        let gameObjects: GameObject[] = [];

        if (multiple){
            let ribbon = SpriteUtils.addImage(this.scene!, CU.CANVAS_WIDTH/2 / CU.S, -57, Keys.RIBBON_FOR_BUNCH, undefined, 7, 2).setOrigin(0.5, 0)
            ribbon.alpha = 0.1;
            let titleText = TextUtils.addTextAdvanced(scene, sc.bunchTitle.toUpperCase(), CU.CANVAS_WIDTH/2 / CU.S, 20,
                '#eec761', 18, 'normal', CU.CANVAS_WIDTH/CU.S, 'left', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0);
            titleText.alpha = 0.9;
            gameObjects.push(ribbon, titleText);
        }

        creatures.forEach((creature:Creature, i:number) => {
            let creaturePanel = new CreaturePanel(scene, 70 + dx, 82 + dy, creature, () => {}, false);
            creaturePanel.setHealthVisible();

            const titleLight = SpriteUtils.addImage(this.scene, 140 - sc.titles[i].length * 5 + dx2, 15 + this.getTitleShift() + dy2, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_LIGHT)
                .setOrigin(0, 0);
            SpriteUtils.setDispSize(titleLight, 360 / 11.5 * sc.titles[i].length * CU.S * (multiple ? 17/22 : 1), 65 * CU.S);

            let titleText = TextUtils.addTextAdvanced(scene, sc.titles[i], 140+ dx2, 50 + this.getTitleShift() + dy2,
                '#eec761', multiple? 17: 22, 'normal', 350, 'left', 2, Fonts.BENGALY_NORMAL);
            titleText.setStroke('#000000', 1);

            let type = TextUtils.addTextAdvanced(scene, Tr('klass'), 140+ dx2, titleText.y / CU.S + this.getTypeShift(),
                '#d7d7d7', 12, 'normal', 350, 'left', 2, Fonts.MYRIADPRO_REGULAR);

            let typeVal = TextUtils.addTextAdvanced(scene, CreatureUtils.getClassName(sc.creature.warriorClass), type.getTopRight().x! / CU.S + 5, titleText.y / CU.S + this.getTypeShift(),
                '#9cdb57', 12, 'normal', 350, 'left', 2, Fonts.MYRIADPRO_REGULAR);

            let icon = SpriteUtils.addImage(this.scene!, typeVal.getTopRight().x! / CU.S + 24, titleText.y / CU.S + 9 + this.getTypeShift(), Keys.ATLAS_UI, Keys.UI_STAT_MINE_CIRCLE)
                .setOrigin(0.8);
            icon.setInteractive().on('pointerup', function(pointer: any) {
                OnceCaller.doOnce('heroManual', () => {
                    statClickCallback(creature.imageId);
                });
            });

            let descText = TextUtils.addTextAdvanced(scene, sc.descriptions[i].toUpperCase(), 140+ dx2, type.y / CU.S + this.getDescriptionShift(),
                '#716f6a', 12, 'normal', 320, 'left', 1, Fonts.MYRIADPRO_REGULAR);
            descText.setOrigin(0, 0);
            if(multiple){
                descText.x = Math.max(icon.getTopRight().x!,  titleText.getTopRight().x!) + 10;
                descText.y = titleText.getTopRight().y!;
                descText.style.setWordWrapWidth((CU.CANVAS_WIDTH - descText.x) - 20);
            }

            gameObjects.push(creaturePanel, titleLight, titleText, type, typeVal, icon, descText);

            dx+=100;
            dy2+=70;
        })

        const separator = SpriteUtils.addSprite(this.scene!, 0, this.height, Keys.ATLAS_SHOP_UI, Keys.UI_SHOP_SEPARATOR, 0.77, 1).setOrigin(0, 1);

        this.add([back, ...gameObjects, /* buyButton,*/ separator]);
    }
    protected getTitleShift(): number {
        return 0;
    }

    protected getTypeShift(): number {
        return 25;
    }

    protected getDescriptionShift(): number {
        return 25;
    }

    protected getButtonText(): string {
        return Tr('kupit');
    }
}
